<a
  class="lesson-item"
  [routerLink]="['/academy/lessons', lesson.id]"
  [attr.aria-current]="current ? 'page' : null"
  [attr.data-status]="status"
>
  <span class="lesson-item__status" [nbTooltip]="'academy.status.' + status | translate">
    <nb-icon [icon]="icon"></nb-icon>
  </span>
  <span class="lesson-item__text">
    <span class="lesson-item__title">
      <span class="lesson-item__index" *ngIf="index !== undefined">{{ index + 1 }}.</span>
      {{ title }}
    </span>
    <span class="lesson-item__subtitle" *ngIf="subtitle">{{ subtitle }}</span>
    <span class="lesson-item__summary" *ngIf="summary">{{ summary }}</span>
  </span>
  <span class="lesson-item__badges">
    <ng-container *ngIf="!compact">
    <span class="academy-chip" *ngIf="isNew">{{ 'academy.badge.new' | translate }}</span>
    <span class="academy-chip academy-chip--hint" *ngIf="lesson.hintId" [nbTooltip]="'academy.badge.hintTooltip' | translate">
      <nb-icon icon="bulb-outline"></nb-icon>
      {{ 'academy.badge.hint' | translate }}
    </span>
    </ng-container>
    <span class="academy-chip academy-chip--success" *ngIf="showStatus && status === 'completed'">
      {{ 'academy.status.completed' | translate }}
    </span>
    <span class="academy-chip" *ngIf="showStatus && status === 'started'">
      {{ 'academy.status.started' | translate }}
    </span>
    <span class="lesson-item__minutes">
      {{ 'academy.minutes' | translate: { n: lesson.minutes } }}
    </span>
  </span>
</a>
